export default __webpack_public_path__ + "static/media/business-model-canvas.7a1e5dd9.svg";